var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CHECK - Img"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M81.0842 16.5176C45.4975 16.5176 16.5176 45.4975 16.5176 81.0842C16.5176 116.671 45.4975 145.651 81.0842 145.651C116.671 145.651 145.651 116.671 145.651 81.0842C145.651 45.4975 116.671 16.5176 81.0842 16.5176ZM111.115 69.3721L75.078 105.409C73.8767 106.61 72.3752 107.211 70.8736 107.211C69.3721 107.211 67.8705 106.61 66.6693 105.409L48.0501 87.0904C45.6476 84.6879 45.6476 80.934 48.0501 78.5315C50.4526 76.1291 54.2065 76.1291 56.6089 78.5315L70.7235 92.6461L102.556 60.8133C104.959 58.4108 108.713 58.4108 111.115 60.8133C113.367 63.2157 113.367 66.9696 111.115 69.3721Z",
    fill: "#41BBC9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckImg);
export default __webpack_public_path__ + "static/media/check_img.2711ddcde9d062b24fc7798f23995e2c.svg";
export { ForwardRef as ReactComponent };